export default function goToLink(link) {
    return window.open(link, '_blank');
}